/**
 * The body for a clearable PUT (#815 1f, lib/rental-clearable-update.ts on the
 * API): absent keeps, a value sets, null clears. Only the fields the user
 * changed are sent, and a field emptied that had a value is sent as null.
 *
 * Nothing here decides which fields may be cleared: the API answers a clear it
 * refuses with 400 FIELD_NOT_CLEARABLE, and the form shows that as sent.
 */
export function clearablePatch(
  before: Record<string, string>,
  after: Record<string, string>,
): Record<string, string | null> {
  const body: Record<string, string | null> = {};
  for (const key of Object.keys(after)) {
    const was = (before[key] ?? "").trim();
    const now = (after[key] ?? "").trim();
    if (now === was) continue;
    body[key] = now === "" ? null : now;
  }
  return body;
}

/** A value as the form's string, "" for absent. */
export const formValue = (v: unknown): string => (v === null || v === undefined ? "" : String(v));
